import { Construction } from 'lucide-react';

interface ComingSoonProps {
  title: string;
  slice: string;
}

export default function ComingSoon({ title, slice }: ComingSoonProps) {
  return (
    <div className="rounded-2xl border border-brand-sage/30 bg-white p-8 shadow-sm">
      <div className="mb-3 flex items-center gap-2 text-brand-sage">
        <Construction className="h-5 w-5" />
        <span className="text-xs font-bold uppercase tracking-wide">
          {slice}
        </span>
      </div>
      <h2 className="font-display text-2xl font-black text-brand-forest">
        {title}
      </h2>
      <p className="mt-1 text-sm text-brand-sage">Coming soon.</p>
    </div>
  );
}